import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const plplSupabaseUrl = process.env.REACT_APP_SUPABASE_URL2;
const plplSupabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY2;

const authOptions = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
};

// 메인 Supabase 클라이언트
export const supabase = createClient(supabaseUrl, supabaseAnonKey, authOptions);

// PLPL Supabase 클라이언트
export const plplSupabase =
  plplSupabaseUrl && plplSupabaseAnonKey
    ? createClient(plplSupabaseUrl, plplSupabaseAnonKey, authOptions)
    : null;

// 모든 클라이언트를 객체로 묶어서 관리 (선택사항)
export const supabaseClients = {
  main: supabase,
  plpl: plplSupabase,
};
